module.exports = __webpack_public_path__ + "img/cc-diners-club.313e73c7.svg";